import React from 'react';

const HomeEditBannerThree = ({ themeData }: any) => {
  return (
    <div className="easelaundry-wrapper">
      <div className="container">
        <div className="row">
          <div className="col-lg-6">
            <div
              className="easelaundry-img-right aos-init"
              data-aos="zoom-in-up"
            >
              {themeData?.theme_5?.home?.section_7?.banner && (
                <img
                  src={themeData?.theme_5?.home?.section_7?.banner}
                  className="img-fluid aos-init"
                  alt="Ease to Made Laundry"
                  data-aos="zoom-in-up"
                />
              )}
            </div>
          </div>
          <div className="col-lg-6">
            <div
              data-aos="zoom-in-up"
              className="easelaundry-content-left text-start aos-init"
            >
              <div className="section-title text-start">
                <h2
                  className="text-start"
                  style={{
                    color: `#${themeData?.theme_5?.home?.section_7?.h2color}`,
                  }}
                >
                  {themeData?.theme_5?.home?.section_7?.title}
                </h2>
              </div>
              <div className="">
                <p className='mb-2'
                  style={{
                    color: `#${themeData?.theme_5?.home?.section_7?.paracolor}`,
                  }}
                >
                  {themeData?.theme_5?.home?.section_7?.paragraph1}
                </p>

                <p className='mb-2'
                  style={{
                    color: `#${themeData?.theme_5?.home?.section_7?.paracolor}`,
                  }}
                >
                  {themeData?.theme_5?.home?.section_7?.paragraph2}
                </p>
                <ul className='mb-2'>
                  {themeData?.theme_5?.home?.section_7?.card_section?.map(
                    (items: any, index: any) => {
                      return (
                        <>
                          <li
                            style={{
                              color: `#${themeData?.theme_5?.home?.section_7?.paracolor}`,
                            }}
                          >
                            {index + 1} : {items.text}
                          </li>
                        </>
                      );
                    }
                  )}
                </ul>
                <p className='mb-2'
                  style={{
                    color: `#${themeData?.theme_5?.home?.section_7?.paracolor}`,
                  }}
                >
                  {themeData?.theme_5?.home?.section_7?.paragraph3}
                </p>

                <p className='mb-2'
                  style={{
                    color: `#${themeData?.theme_5?.home?.section_7?.paracolor}`,
                  }}
                >
                  {themeData?.theme_5?.home?.section_7?.paragraph4}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeEditBannerThree;
